import { render, staticRenderFns } from "./WabaSupsisPartnerAdded.vue?vue&type=template&id=f0d8caf0&scoped=true"
import script from "./WabaSupsisPartnerAdded.vue?vue&type=script&lang=js"
export * from "./WabaSupsisPartnerAdded.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisPartnerAdded.vue?vue&type=style&index=0&id=f0d8caf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d8caf0",
  null
  
)

export default component.exports